import(/* webpackMode: "eager" */ "/var/www/smartpocket/src/app/global-error.tsx");
